import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ImpactBar from "@/components/landing/ImpactBar";
import Marquee from "@/components/landing/Marquee";
import MethodSection from "@/components/landing/MethodSection";
import ReceiveSection from "@/components/landing/ReceiveSection";
import TimelineSection from "@/components/landing/TimelineSection";
import ComparisonSection from "@/components/landing/ComparisonSection";
import ExclusivitySection from "@/components/landing/ExclusivitySection";
import PricingSection from "@/components/landing/PricingSection";
import SupportSection from "@/components/landing/SupportSection";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import MobileStickyCta from "@/components/landing/MobileStickyCta";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen bg-white font-sans antialiased" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <ImpactBar />
        <Marquee />
        <MethodSection />
        <ReceiveSection />
        <TimelineSection />
        <ComparisonSection />
        <ExclusivitySection />
        <PricingSection />
        <SupportSection />
        <FinalCta />
      </main>
      <Footer />
      <MobileStickyCta />
    </div>
  );
}
